import Sb from "../abstract/StatefulBehavior";
import classNames from "classnames";
import { ResizeObserver as RoPolyfill } from "@juggle/resize-observer";

const ResizeObserver = (window && window.ResizeObserver) || RoPolyfill;

export default class ExpandContent extends Sb {
  constructor(el, props, refs) {
    super();

    if (!refs.toggle || !refs.collapsedContent) return;

    this.el = el;
    this.props = props;
    this.refs = refs;

    this.state = {
      expanded: false,
      height: this.collapsedHeight,
    };

    this.initToggleClass = refs.toggle.className;
    this.initContentClass = refs.collapsedContent.className;

    this.update();
    this.bindToggle();

    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(this.el);
  }

  get collapsedHeight() {
    const { toggle, snippet } = this.refs;
    return this.elHeight(toggle) + this.elHeight(snippet);
  }

  get fullHeight() {
    const { snippet, collapsedContent } = this.refs;
    return this.elHeight(snippet) + this.elHeight(collapsedContent);
  }

  get animationDuration() {
    const fromCss = getComputedStyle(this.el).getPropertyValue(
      "--transition-duration"
    );
    return fromCss ? parseFloat(fromCss) : 400;
  }

  update = () => {
    const { toggle, collapsedContent } = this.refs;
    const { expanded, height } = this.state;

    toggle.setAttribute("aria-expanded", expanded);
    collapsedContent.setAttribute("aria-hidden", !expanded);

    toggle.className = classNames(this.initToggleClass, {
      "is-toggled": expanded,
    });
    collapsedContent.className = classNames(this.initContentClass, {
      "is-collapsed": !expanded,
      "is-expanded": expanded,
    });

    Object.assign(this.el.style, { maxHeight: `${height}px` });
    // Remove height constraint once expanded
    if (expanded) {
      setTimeout(() => {
        Object.assign(this.el.style, { maxHeight: `none` });
      }, this.animationDuration);
    }
  };

  bindToggle() {
    this.refs.toggle.addEventListener("click", this.handleToggle);
  }

  handleToggle = (event) => {
    if (this.state.expanded) return false;
    // Don't click the wrapper also
    event.stopPropagation();
    this.refs.toggle.removeEventListener("click", this.handleToggle);
    this.resizeObserver.unobserve(this.el);
    this.setState({ expanded: true, height: this.fullHeight });
  };

  handleResize = (entries) => {
    entries.forEach((entry) => {
      if (this.state.height !== this.collapsedHeight)
        this.setState({ height: this.collapsedHeight });
    });
  };

  elHeight(el) {
    return el.getBoundingClientRect().height;
  }
}
